"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.NodeConfigSchema = exports.artifactType = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const tasks_1 = require("../../uiNodes/tasks");
const v4_1 = require("zod/v4");
exports.artifactType = 'generatedCashBalanceFeed';
exports.NodeConfigSchema = tasks_1.TapeBuilderTaskSchema;
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.extend({
    externalFilename: v4_1.z.null(),
    type: v4_1.z.literal(exports.artifactType),
    configuration: exports.NodeConfigSchema,
});
//# sourceMappingURL=node.js.map